module.exports = global.config = {
    baseURL: 'https://blackoctopus-sound.infinitelabyrinth.com',
    buildURL: 'https://blackoctopus-sound.infinitelabyrinth.com',
    devURL: 'https://blackoctopus-sound.infinitelabyrinth.com',
    siteURL: 'https://blackoctopus-sound.infinitelabyrinth.com',
    siteName: 'Black Octopus Sound',
    
    routes: {
        WPRest: '/wp-json/wp/v2/',
        WCRest: '/wp-json/wc/v3/',
        AppRest: '/wp-json/r-flix/v1/',
        jwtRest: '/wp-json/simple-jwt-authentication/v1/',
    },
    //facebookAppID: '475403749277753',
    //googleAppID: '1050502518849-6g87qr5pjr6imqv7rtret7v1lmq3o2iu.apps.googleusercontent.com',

    reCaptchaKey: '6Ldb_dQZAAAAAOH3lngOcRgPjfFD0mXrHZe0IeQS'
};

module.exports = global.navigationPlaceholder = {
    'menu-1': {
        menu: {
            items: [
                {title:'Articles',url:'',classes:'mobile-only'},
                {title:'Genres',url:'',classes:''},
                {title:'Presets',url:'',classes:''},
                {title:'Labels',url:'',classes:''},
                {title:'Software',url:'',classes:''},
                {title:'Free',url:'',classes:''},
                {title:'Gold',url:'',classes:'gold'},
            ]
        }
    },
    'menu-2': {
        menu: {
            items: [
                {title:'Articles',url:'',classes:''},
                {title:'Videos',url:'',classes:''},
                {title:'Contact Us',url:'',classes:''},
                {title:'Subscribe',url:'',classes:''},
                {title:'Genres',url:'',classes:''},
                {title:'Presets',url:'',classes:''},
                {title:'Labels',url:'',classes:''},
                {title:'Software',url:'',classes:''},
                {title:'Free',url:'',classes:''},
                {title:'Submit A Demo',url:'',classes:''},
                {title:'Gold',url:'',classes:'gold'},
            ]
        }
    }
}

